import React, { useState } from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';
import AddCriteriaBody from './AddCriteriaBody';
import CreateOrEditCriteriaBody from './CreateOrEditCriteriaBody';

const AddCriteriaModal = ({
  toggleModal,
  canUseCustomFeedbackCriteria,
  handleUpdate,
  currentUserId,
  selectedCriteria,
}) => {
  const [creatingOrEditing, setCreatingOrEditing] = useState(false);
  const [notificationText, setNotificationText] = useState('');
  const [criterionEditing, setCriterionEditing] = useState(null);
  const [newlySelectedCriteria, setNewlySelectedCriteria] =
    useState(selectedCriteria);

  const modalBodyClasses = classNames('AddCriteriaModal-body', {
    'AddCriteriaModal--maxHeight': !creatingOrEditing,
  });

  const toggleModalState = criterion => {
    setCreatingOrEditing(!creatingOrEditing);
    setCriterionEditing(criterion);
  };

  const setCriterionNotification = notification => {
    setNotificationText(notification);
  };

  const removeDeletedCriterion = criterion => {
    if (newlySelectedCriteria) {
      setNewlySelectedCriteria(
        newlySelectedCriteria.filter(
          existingCriterion => criterion.id !== existingCriterion.id,
        ),
      );
    }
  };

  const updateEditedCriterion = (criterion, id) => {
    if (newlySelectedCriteria) {
      newlySelectedCriteria.forEach(existingCriterion => {
        if (existingCriterion.id === id) {
          existingCriterion.name = criterion.custom_criterion.name;
          existingCriterion.description =
            criterion.custom_criterion.description;
        }
      });
    }
  };

  const closeModal = () => {
    toggleModal();
    handleUpdate(newlySelectedCriteria);
  };

  return (
    <div className="AddCriteriaModal ModalTakeover-container">
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <div className="ModalTakeover-closeButton" onClick={closeModal}>
        <Icon name="error" />
      </div>
      <div className={modalBodyClasses}>
        {!creatingOrEditing && (
          <AddCriteriaBody
            currentUserId={currentUserId}
            canUseCustomFeedbackCriteria={canUseCustomFeedbackCriteria}
            toggleModalState={toggleModalState}
            toggleModal={toggleModal}
            setCriterionNotification={setCriterionNotification}
            handleUpdate={handleUpdate}
            selectedCriteria={newlySelectedCriteria}
            notificationText={notificationText}
          />
        )}
        {creatingOrEditing && (
          <CreateOrEditCriteriaBody
            toggleModalState={toggleModalState}
            setCriterionNotification={setCriterionNotification}
            criterion={criterionEditing}
            removeDeletedCriterion={removeDeletedCriterion}
            updateEditedCriterion={updateEditedCriterion}
          />
        )}
      </div>
    </div>
  );
};

export default AddCriteriaModal;
